/**
 * Helper that gets the first element in the document matching a particular selector
 *
 * @param {mixed} target
 * @param {element} context to query
 * @return {element}
 */
export const $ = function $(target, context) {
  return (context || document).querySelector(target, context);
};

/**
 * Helper that converts the result of querySelectorAll to a plain array
 *
 * @param {mixed} target
 * @param {element} context to query
 * @return {array}
 */
export const $$ = function $$(target, context) {
  let nodes = [];

  if (target instanceof Array) {
    target.forEach(item => {
      if (item instanceof Node) {
        nodes.push(item);
      }
    });
  }

  if (target instanceof NodeList) {
    nodes = Array.from(target);
  }

  if (target instanceof Element) {
    nodes = [target];
  }

  if (typeof target === `string`) {
    nodes = Array.from((context || document).querySelectorAll(target, context));
  }

  return nodes;
};
